import { SessionId } from '@outlook/hxcore_web';
import { getHxInstance } from './getHxInstance';

/**
 * Runs a function inside a new hx session, and releases that session after the
 * function has completed.
 *
 * For use when you want to perform an operation in hx that does not require
 * holding data in the active set (i.e. when you are pulling data only once and do
 * not want the app to receive notifications on the referenced entities)
 **/
export async function runInHxSession<T>(cb: (sessionId: SessionId) => T | Promise<T>): Promise<T> {
    const hxInstance = getHxInstance();
    const sessionId = hxInstance.activeSet.createSession();
    try {
        // disabling tslint rule as we need to await here
        // for the finally block to work properly
        // https://github.com/palantir/tslint/issues/3933
        // tslint:disable-next-line:no-return-await
        return await cb(sessionId);
    } finally {
        hxInstance.activeSet.releaseSession(sessionId);
    }
}
